import { createFileRoute } from '@tanstack/react-router';

import { AiStarGradient } from '@mint-lib/icons';
import {
  buildGuards,
  hasFlagEnabled,
  hasPermission,
  isAgencyCompany,
  not,
} from '@mint-lib/routing-guards';
import { Chat } from '@mint-sdk/api-ai-assistant';

// Flags are read from '@myn/secured'
const aiHubGuard = buildGuards(
  hasFlagEnabled('aiHubAccess'),
  hasPermission('aiHubFeature:view'),
);

// TODO(STZF-23): fix guard duplication with sidebar in permissions refactoring
// Flags are read from '@myn/secured'
const sidebarGuard = buildGuards(
  hasFlagEnabled('aiHubAccess'),
  not(isAgencyCompany),
  hasPermission('aiHubFeature:view'),
);

export const Route = createFileRoute('/_secured/ai-hub/')({
  staticData: {
    commandMeta: ({ t, check }) => {
      // TODO(STZF-23): route and sidebar guards differ; merge them into one guard in permissions refactoring
      if (
        !check(aiHubGuard, '@myn/secured') ||
        !check(sidebarGuard, '@myn/secured')
      ) {
        return;
      }

      return {
        title: t('AI Hub'),
        keywords: [t('chat'), t('assistant')],
        icon: AiStarGradient,
      };
    },
  },
  async beforeLoad({ context }) {
    if (await context.isFlagEnabled('@mint/arm', 'command')) {
      const guardsContext = await context.getGuardContext(
        await context.getInstance('flagsmith', '@myn/secured'),
      );

      if (!aiHubGuard(guardsContext)) {
        throw new Response('Forbidden', { status: 403 });
      }

      return;
    }

    // TODO(STZF-16): remove once the `command` flag is fully rolled out
    const hasAccess = await context.isFlagEnabled(
      '@myn/secured',
      'aiHubAccess',
    );

    const hasViewPermission = await context.hasPermission('aiHubFeature:view');

    if (!(hasAccess && hasViewPermission)) {
      throw new Response('Forbidden', { status: 403 });
    }
  },
  loader: async ({ context }) => {
    await context.getInstance('http', 'defaultApi');
    await context.getInstance('i18n', '@mint-lib/formatting-hooks');
    await context.prefetchQuery(Chat.listRagDocuments({}));
  },
  head: () => ({
    meta: [
      {
        title: 'AI Hub | MINT',
      },
    ],
  }),
});
